import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'are_possible_sources_of_ignition_sufficiently_safeguarded'

export const dataPointDefinition = {
  retracedId: 'are_possible_sources_of_ignition_sufficiently_safeguarded',
  name: 'Are possible sources of ignition sufficiently safeguarded?',
  description:
    'Answer Yes if the facility takes steps to control ALL potential sources of ignition, such as:\r\r\n- Prohibit smoking in the work place;\r\r\n- Ensure safe procedures for heat processes, e.g., boiler, burning of waste materials, cooking; \r\r\n- Avoid stacking materials so high that they are close to a light source;\r\r\n- Boiler(s) are located in a room(s) or area separate from the production floor and office space.',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-fla-1',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 15160,
  sectionId: '2.2.9.2',
  impactArea: 'Flammable and Combustible Materials',
  impactAreaId: 'FLAMMABLE_AND_COMBUSTIBLE_MATERIALS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
